import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import axiosInstance from '@/api/axiosInstance'

export const useWalletBalance = () => {
    return useQuery({
        queryKey: ['wallet-balance'],
        queryFn: async () => {
            const response = await axiosInstance.get('/provider-transactions/wallet_balance/')
            return response.data
        },
    })
}

export const useMyTransactions = () => {
    return useQuery({
        queryKey: ['provider-transactions'],
        queryFn: async () => {
            const response = await axiosInstance.get('/provider-transactions/')
            return response.data
        },
    })
}

export const useWithdrawalMethods = () => {
    return useQuery({
        queryKey: ['withdrawal-methods'],
        queryFn: async () => {
            const response = await axiosInstance.get('/payment-config/withdrawal_methods/')
            return response.data.withdrawal_methods
        },
    })
}

export const useMyWithdrawalRequests = () => {
    return useQuery({
        queryKey: ['withdrawal-requests'],
        queryFn: async () => {
            const response = await axiosInstance.get('/withdrawal-requests/')
            return response.data
        },
    })
}

export const useCreateWithdrawalRequest = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async (data: { amount: number; payment_method_id: string; payment_method_name: string; bank_details: Record<string, string> }) => {
            const response = await axiosInstance.post('/withdrawal-requests/', data)
            return response.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['withdrawal-requests'] })
            queryClient.invalidateQueries({ queryKey: ['wallet-balance'] })
        },
    })
}

export const useCancelWithdrawalRequest = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async (id: number) => {
            const response = await axiosInstance.post(`/withdrawal-requests/${id}/cancel/`)
            return response.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['withdrawal-requests'] })
            queryClient.invalidateQueries({ queryKey: ['wallet-balance'] })
        },
    })
}


